[
    {
        "question": "Who is liable to cover under Employees Compensation Policy",
        "is_answer_multiple": true,
        "is_answer_header": false,
        "is_answer_in_section": false,
        "answer": [
            "The policy indemnifies the Insured i.e. the employer against his liability as an “employer” for acciental injuries (including fatal) sustained by the employees whilst at work. Any employer, whether as a principal or contractor, engaging ‘employees’ as defined in the Employees’ Compensation Act or sharing an employer –employee relationship, can purchase this cover. On payment of extra premium, medical, surgical, and hospital expenses including the cost of transport to hospital for accidental employment injuries are also covered."
        ]
    },
    {
        "question": "What is covered under Employees Compensation Policy?",
        "is_answer_multiple": true,
        "is_answer_header": false,
        "is_answer_in_sections": true,
        "answer": [
            "Temporary Partial Disablement",
            "Permanent Partial Disablement",
            "Total Disablement",
            "Permanent Total Disablement",
            "Death of Employee"
        ],
        "section_header": "The Employees’ Compensation Policy provides coverage for compensation to employees for bodily injury or death caused due to accidents arising out of and in the course of employment.  The policy covers legal liability of an employer under:",
        "section_answer": [
            "The Employees’ Compensation Act, 1923, and subsequent amendments to the said Act prior to the date of issue of the policy",
            "Common Law"
        ]
    },
    {
        "question": "What is not covered under Employees Compensation Policy?",
        "is_answer_multiple": true,
        "is_answer_header": false,
        "is_answer_in_sections": false,
        "answer": [
            "War group and nuclear group of perils",
            "Liability to employees of contractors of the insured (unless specifically declared)",
            "Liability of insured assumed under an agreement",
            "For any incapacity or death of an Employee resulting from his/her deliberate self-injury or deliberate aggravation of an accidental injury.",
            "Any accident occurring whilst the Employee is under the influence of intoxicating liquor or drugs.",
            "For interest and / or penalty imposed on the Insured under any law or otherwise.",
            "Emotional injuries that are not accompanied by a physical workplace trauma",
            "Any injury which does not result in fatality or partial disablement for a period exceeding 3 days",
            "Injuries received by a fight that an employee started",
            "ESIC Employee",
            "Injury took placewhile coming from home to office or office to home is not covered under WC policy unless it is specifically mentioned in the policy."
        ]
    },
    {
        "question": "Does this policy cover Pre-existing diseases?",
        "is_answer_multiple": true,
        "is_answer_header": false,
        "is_answer_in_sections": false,
        "answer": [
            "Any claim due to or arising out of pre-existing medical condition/ailment whether declared or undeclared is not covered under the policy."
        ]
    },
    {
        "question": "What other additional cover can I opt ?",
        "is_answer_multiple": true,
        "is_answer_header": true,
        "is_answer_in_sections": false,
        "answer_header": [
            "Following additional cover can be opt by paying additional Premium"
        ],
        "answer": [
            "Medical expenses including related hospital, surgical and transportation expenses.",
            "Employees of Contractors / Sub contractor"
        ]
    },
    {
        "question": "In case of Injury including Fatal when and whom should contact",
        "is_answer_multiple": true,
        "is_answer_header": false,
        "is_answer_in_sections": false,
        "answer": [
            "Claim Intimation: In the event of any occurrence which may give rise to a claim under this Policy the Insured shall as soon as possible, and in any case within a period of thirty days of suchoccurrence, give notice thereof to the Company in writing with full particulars. Every letter claim writesummons and process shall be notified to the Company immediately on receipt. Notice shall also be given to the Company immediately the Insured shall have knowledge of any impending prosecution inquest or fatal enquiry in connection with any such occurrence as aforesaid."
        ]
    },
    {
        "question": "Whether Insured can get only medical expenses?",
        "is_answer_multiple": true,
        "is_answer_header": false,
        "is_answer_in_sections": false,
        "answer": [
            "If disablement period is less than 3 days no compensation would be payable i.e insured will not get any compensation for medical expenses."
        ]
    },
    {
        "question": "For how many days employee get a Temporary Total Disablement compensation?",
        "is_answer_multiple": true,
        "is_answer_header": false,
        "is_answer_in_sections": false,
        "answer": [
            "A workman gets 50% of wages under this disablement up to 5 years of disablement or as advised by doctor, whichever is shorter. (An amount equal to 50% of Monthly wages subject to maximum Rs. 7500/-"
        ]
    },
    {
        "question": "If insured has not followed his SOP / not followed the safety rules. Is it is payable.",
        "is_answer_multiple": true,
        "is_answer_header": false,
        "is_answer_in_sections": false,
        "answer": [
            "If insured has not taken reasonable precautions to prevent accidents and disease and shall not comply with all statutory obligations, manufacturer's recommendations and other safety regulations in conduct of the Business then claim is not payable under WC policy."
        ]
    },
    {
        "question": "If insured employee has PPD/PTD and also have a loss of wages. Can he will be benefited in weekly compensation as well as disability compensation.",
        "is_answer_multiple": true,
        "is_answer_header": false,
        "is_answer_in_sections": false,
        "answer": [
            "No he will get only one compensation i.e either weekly benefitordisability compensation."
        ]
    }
]